import { FieldValues } from "react-hook-form";

import { getUserToken, INSTITUTION_ADMINS_URL } from "./utils";

export const createInstitutionAdmin = async (
  data: FieldValues
): Promise<Response> => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${await getUserToken()}`,
    },
    body: JSON.stringify(data),
  };
  return fetch(INSTITUTION_ADMINS_URL, requestOptions);
};

export const editInstitutionAdmin = async (
  data: FieldValues,
  id: string | undefined
): Promise<Response> => {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${await getUserToken()}`,
    },
    body: JSON.stringify(data),
  };
  return fetch(`${INSTITUTION_ADMINS_URL}/${id}`, requestOptions);
};

export const deleteInstitutionAdmin = async (id: string): Promise<Response> => {
  const requestOptions = {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${await getUserToken()}`,
    },
  };
  return fetch(`${INSTITUTION_ADMINS_URL}/${id}`, requestOptions);
};

export const getInstitutionAdminList = async (pageIndex: number) => {
  return await fetch(`${INSTITUTION_ADMINS_URL}?page=${pageIndex}&size=10`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${await getUserToken()}`,
    },
  });
};
